"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _add2 = _interopRequireDefault(require("lodash/add"));
var _reduce2 = _interopRequireDefault(require("lodash/reduce"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _angieslistAppPlatform = require("angieslist-app-platform");
var _redux = require("redux");
var _memberMgmtGatewayActionKeys = _interopRequireDefault(require("../constants/memberMgmtGatewayActionKeys"));
var memberMgmtActions = _interopRequireWildcard(require("../actions/memberMgmtGatewayActions"));
var serviceProviderGatewayActions = _interopRequireWildcard(require("../actions/serviceProviderGatewayActions"));
var _immutable = require("immutable");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var sideEffectsReducer = (0, _angieslistAppPlatform.createReducer)({}, {
  'GET_USER_SUCCESS': function GET_USER_SUCCESS(state, action) {
    action.addSideEffect(function (store) {
      var storeState = store.getState();
      var userId = action.payload.body.userId;
      var pathName = (0, _get2["default"])(storeState, 'routing.locationBeforeTransitions.pathname');
      var appName = (0, _get2["default"])(storeState, 'config.appName');
      if (pathName === '/app/account' || pathName === '/app/account/' || pathName === '/app/account/preferences') {
        store.dispatch(memberMgmtActions.fetchUser(userId));
        if (appName === 'member-app') {
          store.dispatch(memberMgmtActions.getUserContactPreferences(userId));
          store.dispatch(memberMgmtActions.getMembershipInformation(userId));
          store.dispatch(memberMgmtActions.getEligibleForRefund());
        } else {
          store.dispatch(serviceProviderGatewayActions.getAssociateContactPreferences(userId));
        }
      }
    });
    return state;
  },
  'ADD_LOCATION_SUCCESS': function ADD_LOCATION_SUCCESS(state, action) {
    action.addSideEffect(function (store) {
      var pathName = (0, _get2["default"])(store.getState(), 'routing.locationBeforeTransitions.pathname').toLowerCase();
      var userId = (0, _get2["default"])(store.getState(), 'memberManagementGateway.fetchUser.response.userId');
      if (pathName === '/app/account' || pathName === '/app/account/' || pathName === '/app/account/preferences') {
        store.dispatch(memberMgmtActions.reFetchUser(userId));
      }
    });
    return state;
  }
});
var membershipInformationDetailsReducer = (0, _angieslistAppPlatform.createReducer)(new _immutable.Map({
  eligibleForRefund: false
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _memberMgmtGatewayActionKeys["default"].GET_MEMBERSHIP_INFORMATION_SUCCESS, function (state, action) {
  var payloadBody = (0, _get2["default"])(action, ['payload', 'body']);
  var updatedState = new _immutable.Map();
  var primaryMemberships = (0, _get2["default"])(payloadBody, 'primaryMemberships', []);
  var payloadTierName = (0, _get2["default"])(payloadBody, ['tier', 'tierName'], '');
  updatedState = updatedState.merge(new _immutable.Map({
    hasPrimarySubscriptionDetails: primaryMemberships.length > 0,
    tier: payloadTierName.toLowerCase(),
    isClassic: payloadTierName === 'classic',
    isGreen: payloadTierName === 'green',
    primaryMarket: (0, _get2["default"])(payloadBody, 'primaryMarket', '')
  }));
  if (updatedState.get('hasPrimarySubscriptionDetails')) {
    var primaryMembership = primaryMemberships[0];
    updatedState = updatedState.merge(new _immutable.Map({
      term: (0, _get2["default"])(primaryMembership, 'term'),
      renewalDate: (0, _get2["default"])(primaryMembership, 'renewalDate'),
      renewalPrice: (0, _get2["default"])(primaryMembership, ['renewalPrice', 'amount']),
      renewalType: (0, _get2["default"])(primaryMembership, 'renewalType', '').toLowerCase(),
      autoRenewalDescription: (0, _get2["default"])(primaryMembership, 'renewalType').toLowerCase() === 'auto' ? 'Auto Renew' : 'Manual Renew',
      isPayingMember: !!(0, _reduce2["default"])(primaryMemberships.map(function (m) {
        return (0, _get2["default"])(m, ['renewalPrice', 'amount'], 0);
      }), _add2["default"]) && !updatedState.get('isGreen', false)
    }));
    updatedState = updatedState.set('isExpired', new Date() > new Date((0, _get2["default"])(primaryMembership, 'renewalDate')));
  }
  return state.mergeDeep(updatedState);
}), _memberMgmtGatewayActionKeys["default"].GET_ELIGIBLE_FOR_REFUND_SUCCESS, function (state, action) {
  var payloadBody = (0, _get2["default"])(action, ['payload', 'body']);
  return state.mergeDeep(new _immutable.Map({
    eligibleForRefund: (0, _get2["default"])(payloadBody, 'eligibleForRefund', false)
  }));
}));
var _default = exports["default"] = (0, _redux.combineReducers)({
  sideEffects: sideEffectsReducer,
  membershipInformationDetails: membershipInformationDetailsReducer
});
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/reducers/myAccountUIReducer.js
// module id = 4401
// module chunks = 9